import { TableBody, TableCell, TableRow } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getUploadCurveLabel,
  hiddenPressNo,
  uploadCurveStatus,
} from "../../../model/Common";
import { selector as officeStoreSelector } from "../../../store/OfficeStore";
import { fetchListReferenceLines } from "../../../store/ReferenceLineStore";
import { ProgressView } from "../../share";
import useStyles from "../useStyles";

import PressManagementDialog from "./PressManagementDialog";

/**
 * PressManagementTableBodyコンポーネント.
 *
 * @param {object} sortState ソート状態
 * @return {object} コンポーネント
 */
function PressManagementTableBody(props) {
  // 引数
  const { sortState } = props;

  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  // ダイアログの表示状態State (true: 表示 / false: 非表示)
  const [isOpenDialog, setIsOpenDialog] = React.useState(false);
  const [selectOfficeInfo, setSelectOfficeInfo] = React.useState({});

  // テーブル行クリック時の処理
  const handleTableRowClick = (officeInfo) => {
    setSelectOfficeInfo(officeInfo);
    // グラフ線図データ取得
    dispatch(fetchListReferenceLines(officeInfo.serialNumber));
    // ダイアログOpen
    setIsOpenDialog(true);
  };

  // ダイアログClose時の処理
  const handleDialogClose = () => {
    setIsOpenDialog(false);
  };

  // Store情報
  const {
    // 読み込み中フラグ (true: 表示 / false: 非表示)
    isLoading,
    // 拠点情報一覧
    sortedOfficeInfos,
  } = useSelector(officeStoreSelector);

  const styleUploadCurve = (uploadCurve) => {
    let style;
    switch (uploadCurve) {
      case uploadCurveStatus.success.value:
        style = { color: "limegreen", fontWeight: "bold" };
        break;
      case uploadCurveStatus.error.value:
      case uploadCurveStatus.none.value:
        style = { color: "red", fontWeight: "bold" };
        break;
      default:
        style = undefined;
        break;
    }
    return style;
  };

  return (
    <TableBody>
      {isLoading ? (
        <TableRow>
          <TableCell colSpan={4}>
            <ProgressView />
          </TableCell>
        </TableRow>
      ) : (
        <>
          {!sortedOfficeInfos || !sortedOfficeInfos.length ? (
            <TableRow>
              <TableCell>-</TableCell>
              <TableCell>-</TableCell>
              <TableCell>-</TableCell>
              <TableCell>-</TableCell>
            </TableRow>
          ) : (
            <>
              {sortedOfficeInfos.map((sortedOfficeInfo) => (
                <Fragment key={sortedOfficeInfo.serialNumber}>
                  {!hiddenPressNo.includes(sortedOfficeInfo.serialNumber) && (
                    <TableRow
                      hover
                      onClick={() => handleTableRowClick(sortedOfficeInfo)}
                    >
                      <TableCell>
                        <div className={styles.flexStart}>
                          <div
                            className={`${styles.machineNameText} ${styles.wordBreak}`}
                          >
                            {sortedOfficeInfo.serialNumber}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>{sortedOfficeInfo.label}</TableCell>
                      <TableCell>{sortedOfficeInfo.pressType}</TableCell>
                      <TableCell
                        style={styleUploadCurve(sortedOfficeInfo.uploadCurve)}
                      >
                        {getUploadCurveLabel(sortedOfficeInfo.uploadCurve)}
                      </TableCell>
                    </TableRow>
                  )}
                </Fragment>
              ))}
              <PressManagementDialog
                isOpenDialog={isOpenDialog}
                onClose={handleDialogClose}
                serialNumber={selectOfficeInfo.serialNumber}
                label={selectOfficeInfo.label}
                sortState={sortState}
              />
            </>
          )}
        </>
      )}
    </TableBody>
  );
}

PressManagementTableBody.propTypes = {
  sortState: PropTypes.shape({
    key: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default PressManagementTableBody;
